export default {
    partLoading: false,
    partsListLoading: false,
    partsList: [],
}